











import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { ModelSync, Prop } from 'vue-property-decorator'
import { BankNames } from '@/modules/bank-account/models/bank-account-resource.model'
import { InputHelper } from '@/modules/shared/helpers/input'

@Component({
  components: {
    BaseSelect
  }
})
export default class BankAccountNameSelectInput extends Vue {
  @ModelSync('bankName', 'change') bankNameModel: BankNames
  @Prop({ required: true }) bankNames: { [key in BankNames] }

  get bankNameOptions() {
    return InputHelper.convertToOptions(this.bankNames)
  }
}
